import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import Dropdown from '../../../../components/Dropdown/Dropdown.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MapBandRow',
  props: {
    label: null,
    options: null,
    value: null,
    disabled: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any) {

const props = __props as {
	label: string
	options: Array<{ value: string; label: string }>
	value: string | undefined
	disabled?: boolean
};





const boxStyle = computed(() => {
	return props.value ? 'border-blue-tints bg-blue-tint-4' : 'border-gray-medium bg-light-2'
})

return { __sfc: true,props, boxStyle, Dropdown }
}

})